import axios from "axios";

export default function ReceiptParentAddService(formData, receiptId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + receiptId + "/children",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
